import { api, ApiError } from "@/api/api";
import { AssetsReadyForSubmissionResponseData } from "@/api/submission-types";
import { QueryModels } from "@/api/utils";
import { prepareQueryParams } from "@/utils/prepare-query-params";
import { useQuery } from "@tanstack/react-query";

export function useAssetsReadyForSubmission(queryModels: QueryModels) {
  const queryParams = prepareQueryParams(queryModels);

  return useQuery<AssetsReadyForSubmissionResponseData, ApiError>({
    queryKey: ["GET", "submission", "assetsReadyForSubmission", queryModels],
    queryFn: () => api.submission.assetsReadyForSubmission.get(queryParams),
  });
}
